/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit PlanCosts.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Info from 'DesignSystem/Info/view.js'
import PlanBasic from './PlanBasic/view.js'
import PlanEnhanced from './PlanEnhanced/view.js'
import PlanOptions from './PlanOptions/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  flexBasis: "auto",
flexGrow: 1,
flexShrink: 1,
paddingBottom: 100})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
flexBasis: "auto",
flexGrow: 1,
flexShrink: 1,
marginTop: 40,
paddingRight: 40,
marginLeft: 100})

export default function PlanCosts({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Plans/Content/PlanCosts"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="PlanCosts.Vertical"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
 className={`views-block ${styles.Vertical}`}
>
<div
 data-testid="PlanCosts.Horizontal"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
 className={`views-block ${styles.Horizontal}`}
>
<PlanOptions
 data-testid="PlanCosts.PlanOptions"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
viewPath={`${viewPath}/PlanOptions`}
/>
<PlanBasic
 data-testid="PlanCosts.PlanBasic"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
viewPath={`${viewPath}/PlanBasic`}
/>
<PlanEnhanced
 data-testid="PlanCosts.PlanEnhanced"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
viewPath={`${viewPath}/PlanEnhanced`}
/>
</div>
<Info
 data-testid="PlanCosts.Info"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
viewPath={`${viewPath}/Info`}
 marginLeft={100}
 marginTop={50}
 textOverflow="clip"
 whiteSpace="wrap"
 overflowX="visible"
 text="*Discount is applied to the standard fee schedule of the in-network dentist selected by the member."
/>
<Info
 data-testid="PlanCosts.Info:1"
 data-view-path="/App/MyAccount/Content/Plans/Content/PlanCosts"
viewPath={`${viewPath}/Info`}
 marginLeft={100}
 marginTop={8}
 textOverflow="clip"
 whiteSpace="wrap"
 overflowX="visible"
 text="**Please refer to the full fee schedule for actual costs.  Discounts shown are averages based on a broad range of usual and customary fees."
/>
</div>
{children}
</React.Fragment>)
}